export default function getChannelType() {
  if (window && window.innerWidth <= 800) {
    return 'MSITE';
  }
  return 'WEB';
}
